import React from 'react';
import JiraBaseRedirect from '@atlassian/jira-spa-apps-common/src/redirect/jira-base-routing/index.tsx';

const JiraBaseRedirectWrapper = (): React.JSX.Element => <JiraBaseRedirect />;

export default JiraBaseRedirectWrapper;
